import React, { useState } from "react";
import { connect } from "react-redux";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import AuthActions from "../../../stores/auth/Actions";
import AseguradoActions from "../../../stores/asegurado/Actions";
import PrestadorActions from "../../../stores/prestador/Actions";
import ProcedimientoActions from "../../../stores/procedimiento/Actions";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import CatalogoActions from "../../../stores/catalogo/Actions";
import { useHistory, useLocation } from "react-router-dom";
import AutorizacionForm from "../components/AutorizacionForm";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import AfiliadoForm from "../components/AfiliadoForm";
import ProcedimientosModal from "../components/ProcedimientosModal";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { formatCedula, isEmptyValue } from "../../../utils/StringUtil";
import { cleanNumber } from "../../../utils/NumberUtil";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import { isObjectEmpty, getValueOrSuggestion } from "../../../utils/ObjectUtil";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomFileUpload from "../../../components/CustomFileUpload/CustomFileUpload";
import TittleLine from "../../../components/Common/TittleLine";
import {
  AutorizacionFormButtonsContainer,
  AutorizacionFormButtonsRight,
  AutorizacionFormButtonsLeft,
} from "../styles/AutorizacionStyles";
import {
  INITIAL_STATE_AUTORIZATION_FORM,
  DEFAULT_ROW,
  PAGINAS_PROCEDIMIENTOS,
  columnsProcedimientosPermitidos,
  columnsProcedimientosAgregados,
  DATOS_FIJOS_AUTORIZACION,
  DATOS_FIJOS_ZONAS,
  DATOS_FIJOS_PROVINCIAS,
  DEFAULT_ICON_AVATAR,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
  DEFAULT_TITULO,
  DESCRIPCION_TIPO_AUTORIZACION,
  COBERTURAS_EVENTOS
} from "../utils/AutorizacionConstant";
import { EMPRESA, PROGRAMA } from "../../../utils/Constant";
import {
  getTipoServicioTipoCobertura,
  homologarCodigoTipoServicio,
} from "../utils/AutorizacionUtils";
import { ALERTAS_GENERICAS } from "../../../utils/AlertasGenericas";
import CustomAlert from "../../../components/Common/CustomAlert";
import CheckRender from "../../../components/Common/CheckRender";
import ModalLoader from "../../../components/Common/ModalLoader";
import {
  isValidPhone,
  isValidEmail,
  isValidNumber,
  camposCompletos,
} from "../../../utils/ValidationUtil";
import Colors from "../../../themes/Colors";
import { getActualYear, getAge } from "../../../utils/DateUtils";
import { cleanCurrency, dotsAndNumbers } from "../../../utils/CurrencyUtil";

const AutorizacionScreen = (props) => {
  const history = useHistory();
  const empresa = useEmpresa();
  const location = useLocation();
  const { prestador } = props?.authUserData;
  const [formData, setFormData] = useState(INITIAL_STATE_AUTORIZATION_FORM);
  const [codigoCobertura, setCodigoCobertura] = useState("");
  const [isModalCoberturasOpen, setIsModalCoberturasOpen] = useState(false);
  const [isModalDocumentosOpen, setIsModalDocumentosOpen] = useState(false);
  const [queryProcedimientos, setQueryProcedimientos] = useState("");
  const [queryAfiliado, setQueryAfiliado] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [processing, setProcessing] = useState(false);
  const [showRequired, setShowRequired] = useState(false);
  const [autorizacionEsPyp, setAutorizacionEsPyp] = useState(false);
  const [autorizacionEsCc, setAutorizacionEsCc] = useState(false);
  const [titulo, setTitulo] = useState(DEFAULT_TITULO);
  const [procedimientosBusqueda, setProcedimientosBusqueda] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [listaProvincias, setListaProvincias] = useState([]);
  const [selectedMedico, setSelectedMedico] = useState(null);
  const [selectedDiagnostico, setSelectedDiagnostico] = useState(null);
  const itemsPerPage = PAGINAS_PROCEDIMIENTOS.TAMANO;
  const [currentPage, setCurrentPage] = useState(1);
  const [montoCobertura, setMontoCobertura] = useState("");
  const [tablaProcedimientosData, setTablaProcedimientosData] = useState([
    DEFAULT_ROW,
  ]);

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  useMountEffect(() => {
    cleanAndLoadResources();
    validarConfiguracionPapperFree();
    validarConfiguracionPyp();
    validarConfiguracionCronicosComplejos();
  });

  /**
   * Obtener nueva sesión Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.nuevaSesionData) && processing) {
      const { numeroSesion } = props?.nuevaSesionData;

      limpiarFormulario();

      props.consultarAsegurado({
        numeroSesion,
        numeroPlastico: queryAfiliado,
      });
    }
  }, [props.nuevaSesionData]);

  /**
   * Obtener nueva sesión Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.nuevaSesionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.nuevaSesionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.nuevaSesionError]);

  /**
   * Obtener procedimientos permitidos Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProcedimientosPssData) && processing) {
      setProcessing(false);

      const { coberturas } = props?.getProcedimientosPssData;
      const coberturasFiltradas = filtrarProcedimientos(coberturas);
      
      setProcedimientosBusqueda(coberturasFiltradas);

      setIsModalCoberturasOpen(true);
    }
  }, [props.getProcedimientosPssData]);

  /**
   * Obtener procedimientos permitidos Error..
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProcedimientosPssError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.getProcedimientosPssError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.getProcedimientosPssError]);

  /**
   * Validar procedimiento Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.validarProcedimientoData) && processing) {
      setProcessing(false);

      setCodigoCobertura("");

      setMontoCobertura("");

      const {
        codigo,
        nombreCobertura,
        frecuencia,
        montoReclamado,
        montoArs,
        montoAfiliado,
        isFromModal,
        esPaquete,
      } = props?.validarProcedimientoData;

      setTablaProcedimientosData((pre) => {
        return [
          ...pre,
          {
            key: codigo,
            cobertura: codigo,
            nombreCobertura: nombreCobertura,
            cantidad: frecuencia,
            montoReclamado: montoReclamado,
            montoAutorizado: montoArs,
            montoDiferencia: montoAfiliado,
            esPaquete : esPaquete
          },
        ];
      });

      isFromModal && handleCloseModalCoberturas();
    }
  }, [props.validarProcedimientoData]);

  /**
   * Validar procedimiento Error..
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.validarProcedimientoError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.validarProcedimientoError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.validarProcedimientoError]);

  /**
   * Crear Autorizacion Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.crearAutorizacionData) && processing) {
      setProcessing(false);

      const { autorizacion, errorRegistrarInfo } = props?.crearAutorizacionData;

      const { numeroAutorizacion } = autorizacion;

      setAlertConfig({
        type: "success",
        title: `¡Autorización ${numeroAutorizacion} guardada con éxito!`,
        message: `Reclamación enviada. (${numeroAutorizacion})`,
        aditionalInfo:
          props?.crearAutorizacionData?.mensajeProcedimientosNoInsertados ||
          errorRegistrarInfo,
        onConfirm: () => {
          setShowAlert(false);

          limpiarFormulario();

          history.push({
            pathname: "/detalle-autorizacion",
            state: {
              autorizacion: {
                ...autorizacion,
                ano: getActualYear(),
              },
            },
          });
        },
      });
      setShowAlert(true);
    }
  }, [props.crearAutorizacionData]);

  /**
   * Crear Autorizacion Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.crearAutorizacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.crearAutorizacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.crearAutorizacionError]);

  /**
   * Consultar asegurado Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAseguradoData) && processing) {
      setProcessing(false);

      if (
        !empresaPuedeAutorizar(props?.consultarAseguradoData?.compania?.codigo)
      ) {
        setAlertConfig({
          type: "confirm",
          title: "¡Hola!",
          message: `${empresa?.REDIRECT_COMPANY.MESSAGE}`,
          confirmText: `Ir a ${empresa?.REDIRECT_COMPANY.NAME}`,
          onConfirm: () => {
            const newTab = window.open(empresa?.REDIRECT_COMPANY.URL, "_blank");
            newTab.focus();
            setShowAlert(false);
          },
          onCancel: () => {
            setShowAlert(false);
          },
        });

        props.limpiarDatosAfiliado();

        setShowAlert(true);
        return;
      }

      if(autorizacionEsCc){
        if(!
          props?.consultarAseguradoData?.isCcPermitido?.data?.aplica                                                   
        ){
          setAlertConfig({
            type: "info",
            title: "¡Hola!",
            message: props?.consultarAseguradoData?.isCcPermitido?.data?.mensaje,
            onConfirm: () => {
              setShowAlert(false);
            },
          });
          props.limpiarDatosAfiliado();

          setShowAlert(true);
          return;  
        }
        setFormData((prevState) => {
          return {
            ...prevState,
            tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO,
          };
        });
      }

      const {
        numeroPlastico,
        nombres,
        apellidos,
        cedula,
        nss,
        fechaNacimiento,
        plan,
      } = props?.consultarAseguradoData?.afiliado;

      setQueryAfiliado(numeroPlastico);

      setFormData((prevState) => {
        return {
          ...prevState,
          numeroAfiliado: numeroPlastico,
          cedula: formatCedula(cedula),
          nss: nss,
          nombres: nombres,
          apellidos: apellidos,
          edad: getAge(fechaNacimiento),
          plan: plan,
          foto: DEFAULT_ICON_AVATAR,
        };
      });
    }
  }, [props.consultarAseguradoData]);

  /**
   * Consultar asegurado Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.consultarAseguradoError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.consultarAseguradoError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.consultarAseguradoError]);

  /**
   * Obtener listado provincias Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getProvinciasData) && processing) {
      const { provincias } = props?.getProvinciasData;
      setListaProvincias(provincias || []);
    }
  }, [props.getProvinciasData]);

  const cleanAndLoadResources = () => {
    props.limpiarDatosAfiliado();

    props.limpiarDatosAutorizacion();

    props.clearSesion();

    props.getDiagnosticos();

    if (prestadorTieneConfiguradoPapperFree()) {
      props.getZonas({
        paisId: DATOS_FIJOS_ZONAS.PAIS_ID,
        tipoDistribucionPoliticaId:
          DATOS_FIJOS_ZONAS.TIPO_DISTRIBUCION_POLITICA_ID,
      });
    }
  };

  const empresaPuedeAutorizar = (codigoEmpresaAsegurado) => {
    return (
      Number(empresa?.CODIGO) === Number(codigoEmpresaAsegurado) ||
      autorizacionEsPyp || autorizacionEsCc
    );
  };

  const prestadorTieneConfiguradoPapperFree = () => {
    return props?.authUserData?.configuracionPaperFree?.esPaperFree;
  };

  const validarConfiguracionPapperFree = () => {
    if (prestadorTieneConfiguradoPapperFree()) {
      setFormData((prevState) => {
        return {
          ...prevState,
          requiereFisico: "No",
        };
      });
    }
  };

  const validarConfiguracionPyp = () => {
    let program = location?.state?.program;

    if (!program) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      program = params.get("program");
    }

    const esPyp =
      program === PROGRAMA.PROMOCION_PREVENCION.CODIGO &&
      prestador.pyp &&
      isPrimera;

    setAutorizacionEsPyp(esPyp);

    if (esPyp) {
      setTitulo(`Agregar Reclamación ${PROGRAMA.PROMOCION_PREVENCION.DESCRIPCION}`);
      setFormData((prevState) => {
        return {
          ...prevState,
          tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.PROMOCION_PREVENCION,
        };
      });
    }
  };

  const validarConfiguracionCronicosComplejos = () => {
    let program = location?.state?.program;

    if (!program) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      program = params.get("program");
    }

    const cc =
      program === PROGRAMA.CRONICO_COMPLEJO.CODIGO &&
      isPrimera;

    setAutorizacionEsCc(cc);

    if (cc) {
      setTitulo(`Agregar Reclamación ${PROGRAMA.CRONICO_COMPLEJO.DESCRIPCION}`);

      setFormData((prevState) => {
        return {
          ...prevState,
          tipoServicio: CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO,
        };
      });
    }
  };

  const noRequiereFisico = () => {
    return formData?.requiereFisico === "No";
  };

  const tieneCoberturaYservicio = (
    coberturaCodigo,
    codigoTipoServicio,
    coberturasConfiguradas
  ) => {
    if (coberturasConfiguradas?.length > 0) {
      const coberturaEncontrada = coberturasConfiguradas?.find((cobertura) => {
        return (
          cobertura.codigoCobertura === coberturaCodigo &&
          cobertura.servicio === codigoTipoServicio
        );
      });

      if (coberturaEncontrada) {
        return true;
      }
    }

    return false;
  };

  const validarFisicoRequerido = (coberturaCodigo) => {
    const { tipoServicio } = formData;

    const { configuracionPaperFree } = props?.authUserData;

    if (noRequiereFisico()) {
      if (
        !tieneCoberturaYservicio(
          Number(coberturaCodigo),
          Number(homologarCodigoTipoServicio(tipoServicio)),
          configuracionPaperFree?.configuracionRadicacionWeb
        )
      ) {
        setFormData((prevState) => {
          return {
            ...prevState,
            requiereFisico: "Si",
          };
        });

        setAlertConfig({
          type: "info",
          title: "¡Hola!",
          message:
            "Debido a que usted está agregando una cobertura que sí requieren el físico, la reclamación cambiará de “Físico no Requerido” a “Físico Requerido”!",
          onConfirm: () => {
            setShowAlert(false);
          },
        });
        setShowAlert(true);
      }
    }
  };

  const handleOpenModalCoberturas = () => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    setProcessing(true);

    setCurrentPage(PAGINAS_PROCEDIMIENTOS.PAGINA);

    const requestData = {
      servicio: homologarCodigoTipoServicio(formData?.tipoServicio),
      pagina: PAGINAS_PROCEDIMIENTOS.PAGINA,
      tamanoPagina: itemsPerPage,
      applyFilter: false,
    };

    if (requestData.servicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO) {
      requestData.esPaquete = true;
    }

    props.getProcedimientosPss(requestData);
  };

  const filtrarProcedimientos = (procedimientos) => {
    return procedimientos.filter((proc) => {
      if (proc.servicio === DESCRIPCION_TIPO_AUTORIZACION.CRONICO_COMPLEJO) {
        return !COBERTURAS_EVENTOS.includes(proc.cobertura);
      }
      return true;
    });
  };
  

  const handleCloseModalCoberturas = () => {
    setIsModalCoberturasOpen(false);
  };

  const handleOpenModalDocumentos = () => {
    setIsModalDocumentosOpen(true);
  };

  const handleCloseModalDocumentos = () => {
    setIsModalDocumentosOpen(false);
  };

  const validarFormularioAutorizacion = () => {
    if (!afiliadoEncontrado()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `Recuerda que primero debes hacer la búsqueda de el ${empresa?.TIPO_CLIENTE}.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return false;
    }

    if (!camposRequeridosCompletos()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: ALERTAS_GENERICAS.CAMPOS_REQUERIDOS,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      setShowRequired(true);
      return false;
    }

    const { telefono, correo } = formData;

    if (
      !isValidPhone(telefono) ||
      (!isEmptyValue(correo) && !isValidEmail(correo))
    ) {
      return;
    }

    return true;
  };

  const procedimientoYaExiste = (codigoProcedimiento) => {
    if (
      tablaProcedimientosData.some(
        (procedimiento) => procedimiento.cobertura === codigoProcedimiento
      )
    ) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `El procedimiento ${codigoProcedimiento} ya fue agregado.`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return true;
    }

    return false;
  };

  const afiliadoEncontrado = () => {
    return !isObjectEmpty(props?.consultarAseguradoData);
  };

  const camposRequeridosCompletos = () => {
    const {
      fecha,
      tipoTelefono,
      telefono,
      tipoServicio,
      zona,
      provincia,
      diagnostico,
    } = formData;

    if (noRequiereFisico()) {
      return camposCompletos({
        fecha,
        tipoTelefono,
        telefono,
        tipoServicio,
        zona,
        provincia,
        diagnostico,
      });
    }

    if (autorizacionEsCc) {
      return camposCompletos({
        fecha,
        tipoTelefono,
        telefono
      });
    }
    
    return camposCompletos({
      fecha,
      tipoTelefono,
      telefono,
      tipoServicio,
    });
  };

  const tieneCoberturasAgregadas = () => {
    return tablaProcedimientosData?.length > 1;
  };

  const handleValueChange =
    (key, format = null) =>
    (value, applyFilter = true) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });

      if (key === "zona") {
        setFormData((prevState) => {
          return {
            ...prevState,
            provincia: "",
          };
        });

        if (isEmptyValue(value)) {
          setListaProvincias([]);
        } else {
          setProcessing(true);
          props.getProvincias({
            paisId: DATOS_FIJOS_PROVINCIAS.PAIS_ID,
            tipoDistribucionPoliticaId:
              DATOS_FIJOS_PROVINCIAS.TIPO_DISTRIBUCION_POLITICA_ID,
            distribucionPoliticaSuperiorId: Number(value),
          });
        }
      }

      if (key === "medicoPrescriptor") {
        if (applyFilter && prestadorTieneConfiguradoPapperFree()) {
          consultarMedicos(value);
        }
      }

      if (key === "diagnosticoDefinitivo") {
        setFormData((prevState) => {
          return {
            ...prevState,
            [key]: value?.target?.checked,
          };
        });
      }
    };

  const handleCheckboxChange = (key) => (value) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [key]: value?.target?.checked,
      };
    });
  };

  const consultarMedicos = (value) => {
    if (isEmptyValue(value)) {
      return;
    }

    if (isValidNumber(value)) {
      props.getMedicos({ codigoMedico: value });
      return;
    }

    if (value.length >= 3) {
      props.getMedicos({ nombreMedico: value });
    }
  };

  const handleCodigoCobertura = (value) => {
    setCodigoCobertura(cleanNumber(value));
  };

  const onChangeMontoCobertura = (value) => {
    setMontoCobertura(cleanCurrency(value));
  };

  const onQueryProcedimientosChange = () => (value) => {
    setQueryProcedimientos(value);
    filtrarBusqueda(value);
  };

  const onQueryAfiliadoChange = () => (value) => {
    setQueryAfiliado(cleanNumber(value));
  };

  const enviarAutorizacion = () => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    if (!tieneCoberturasAgregadas()) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor agregar los procedimientos.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setProcessing(true);

    const {
      esArl,
      medicoPrescriptor,
      diagnostico,
      tipoTelefono,
      telefono,
      correo,
      zona,
      provincia,
      observaciones,
      tipoServicio,
      diagnosticoDefinitivo,
    } = formData;

    const { zonas } = props?.getZonasData;

    const zonaSelected = zonas?.find(
      (item) => Number(item.value) === Number(zona)
    );

    const procedimientos = tablaProcedimientosData?.filter(
      (item) => item.key !== DEFAULT_ROW.key
    );

    props.crearAutorizacion({
      numeroSesion: props?.nuevaSesionData?.numeroSesion,
      tipoServicio: getTipoServicioTipoCobertura(
        homologarCodigoTipoServicio(tipoServicio)
      ),
      servicio: homologarCodigoTipoServicio(tipoServicio),
      requestAutorizar: {
        preAutorizar: true,
        esARL: esArl === "Si",
      },
      insertarMetadata: true,
      requestRegistrarInfo: {
        contacto: {
          tipoTelefono: tipoTelefono,
          telefono: Number(cleanNumber(telefono)),
          email: correo,
          codigoZona: noRequiereFisico()
            ? Number(zonaSelected?.id)
            : DATOS_FIJOS_ZONAS.DEFAULT_ZONA,
          codigoProvincia: noRequiereFisico()
            ? Number(provincia)
            : DATOS_FIJOS_PROVINCIAS.DEFAULT_PROVINCIA,
        },
        diagnosticos: [
          {
            codigoDiagnostico:
              getValueOrSuggestion(selectedDiagnostico, diagnostico)?.codigo ||
              DATOS_FIJOS_AUTORIZACION.CODIGO_DIAGNOSTICO_NO_CAPTURADO,
            esDiagnosticoDefinitivo: diagnosticoDefinitivo,
            esPrimerDiagnostico: true,
          },
        ],
        medicoTratante: {
          codigoMedico: Number(
            getValueOrSuggestion(selectedMedico, medicoPrescriptor)?.codigo
          ),
          nombreMedico: getValueOrSuggestion(selectedMedico, medicoPrescriptor)
            ?.descripcion,
        },
        comentarios: isEmptyValue(observaciones)
          ? []
          : [
              {
                comentario: observaciones,
              },
            ],
        exentoDeFisico: noRequiereFisico(),
      },
      documents: documents,
      procedimientos,
    });
  };

  const onSearchAfiliado = () => {
    if (isEmptyValue(queryAfiliado)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: `Favor ingresar número de ${empresa?.TIPO_CLIENTE}`,
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    setProcessing(true);

    props.nuevaSesion({
      codigo: prestador?.codigo,
    });
  };

  const onCleanForm = () => {
    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: `Recuerda que si limpias los datos tendrás que iniciar desde cero.`,
      onConfirm: () => {
        limpiarFormulario();
        setShowAlert(false);
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const limpiarFormulario = () => {
    setFormData((prevState) => {
      return {
        ...prevState,
        ...INITIAL_STATE_AUTORIZATION_FORM,
      };
    });

    setQueryAfiliado("");

    setTablaProcedimientosData([DEFAULT_ROW]);

    props.limpiarDatosAfiliado();

    validarConfiguracionPapperFree();

    validarConfiguracionPyp();
  };

  const agregarProcedimientoDesdeModal = (record) => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    const { tipoServicio } = formData;

    const { nombreCobertura, cobertura } = record;

    const { numeroSesion } = props?.nuevaSesionData;

    if (procedimientoYaExiste(Number(cobertura))) {
      return;
    }

    validarFisicoRequerido(Number(cobertura));

    setProcessing(true);
    props.validarProcedimiento({
      numeroSesion: Number(numeroSesion),
      codigoProcedimiento: Number(cobertura),
      tipoServicio: getTipoServicioTipoCobertura(
        homologarCodigoTipoServicio(tipoServicio)
      ),
      nombreCobertura,
      isFromModal: true,
      monto: dotsAndNumbers(montoCobertura),
      frecuencia: 1,
      servicio: homologarCodigoTipoServicio(tipoServicio),
    });
  };

  const agregarProcedimientoManual = () => {
    if (!validarFormularioAutorizacion()) {
      return;
    }

    if (isEmptyValue(codigoCobertura)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor ingresar el código del procedimiento.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });
      setShowAlert(true);
      return;
    }

    if (procedimientoYaExiste(Number(codigoCobertura))) {
      return;
    }

    const { tipoServicio } = formData;

    validarFisicoRequerido(Number(codigoCobertura));

    const { numeroSesion } = props?.nuevaSesionData;

    setProcessing(true);

    props.validarProcedimiento({
      numeroSesion: Number(numeroSesion),
      codigoProcedimiento: Number(codigoCobertura),
      tipoServicio: getTipoServicioTipoCobertura(
        homologarCodigoTipoServicio(tipoServicio)
      ),
      isFromModal: false,
      frecuencia: 1,
      monto: dotsAndNumbers(montoCobertura),
      servicio: homologarCodigoTipoServicio(tipoServicio),
    });
  };

  const eliminarProcedimiento = (record) => {
    setAlertConfig({
      type: "confirm",
      title: "¿Estás seguro?",
      message: `¿Deseas eliminar el procedimiento ${record?.cobertura}?`,
      onConfirm: () => {
        setTablaProcedimientosData((pre) => {
          return pre.filter((item) => item.key !== record?.key);
        });
        setShowAlert(false);
      },
      onCancel: () => {
        setShowAlert(false);
      },
    });
    setShowAlert(true);
  };

  const filtrarBusqueda = (query) => {
    setProcessing(true);

    setCurrentPage(PAGINAS_PROCEDIMIENTOS.PAGINA);

    let requestProcedimientos = {
      servicio: homologarCodigoTipoServicio(formData?.tipoServicio),
      pagina: PAGINAS_PROCEDIMIENTOS.PAGINA,
      tamanoPagina: itemsPerPage,
      applyFilter: true,
    };

    if (homologarCodigoTipoServicio(formData?.tipoServicio) === CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO) {
      requestProcedimientos.esPaquete = true;
    }

    if (isEmptyValue(query)) {
      props.getProcedimientosPss(requestProcedimientos);
      return;
    }

    if (isValidNumber(query)) {
      requestProcedimientos.cobertura = Number(query);
    } else {
      requestProcedimientos.nombreCobertura = query;
    }

    props.getProcedimientosPss(requestProcedimientos);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);

    setProcessing(true);

    let requestProcedimientos = {
      servicio: homologarCodigoTipoServicio(formData?.tipoServicio),
      pagina: page,
      tamanoPagina: itemsPerPage,
      applyFilter: false,
    };

    if (homologarCodigoTipoServicio(formData?.tipoServicio) === CODIGO_TIPO_SERVICIO_AUTORIZACION.CRONICO_COMPLEJO) {
      requestProcedimientos.esPaquete = true;
    }

    if (isEmptyValue(queryProcedimientos)) {
      props.getProcedimientosPss(requestProcedimientos);
      return;
    }

    if (isValidNumber(queryProcedimientos)) {
      requestProcedimientos.cobertura = Number(queryProcedimientos);
    } else {
      requestProcedimientos.nombreCobertura = queryProcedimientos;
    }

    props.getProcedimientosPss(requestProcedimientos);
  };

  const showModalLoader = () => {
    const {
      nuevaSesionLoading,
      consultarAseguradoLoading,
      getProcedimientosPssLoading,
      validarProcedimientoLoading,
      crearAutorizacionLoading,
      limpiarDatosAseguradoLoading,
    } = props;

    return (
      nuevaSesionLoading ||
      consultarAseguradoLoading ||
      getProcedimientosPssLoading ||
      validarProcedimientoLoading ||
      crearAutorizacionLoading ||
      limpiarDatosAseguradoLoading
    );
  };

  const disableFields = () => {
    const {
      validarProcedimientoLoading,
      crearAutorizacionLoading,
      crearAutorizacionData,
    } = props;

    return (
      validarProcedimientoLoading ||
      crearAutorizacionLoading ||
      !isObjectEmpty(crearAutorizacionData)
    );
  };

  const getAutorizationFormProps = () => {
    const {
      getZonasLoading,
      getProvinciasLoading,
      getDiagnosticosLoading,
      getMedicosLoading,
    } = props;

    return {
      data: formData,
      diagnosticos: props?.getDiagnosticosData?.diagnosticos || [],
      zonas: props?.getZonasData?.zonas || [],
      provincias: listaProvincias || [],
      medicos: props?.getMedicosData?.medicos || [],
      onStateChange: handleValueChange,
      handleCheckboxChange,
      showRequired: showRequired,
      disabled: disableFields(),
      setSelectedMedico: setSelectedMedico,
      setSelectedDiagnostico: setSelectedDiagnostico,
      noRequiereFisico: noRequiereFisico(),
      prestadorEsPapperFree: prestadorTieneConfiguradoPapperFree(),
      getZonasLoading,
      getProvinciasLoading,
      getDiagnosticosLoading,
      getMedicosLoading,
      updatedSuggestionsMedicos: props?.getMedicosData?.medicos,
      autorizacionEsPyp,
      autorizacionEsCc,
    };
  };

  const getAfiliadoFormProps = () => {
    const { cedula, nss, nombres, apellidos, edad, foto } = formData;

    return {
      queryAfiliado: queryAfiliado,
      cedula,
      nss,
      nombres,
      apellidos,
      edad,
      foto,
      onStateChange: handleValueChange,
      onSearch: onSearchAfiliado,
      onClean: onCleanForm,
      onQueryAfiliadoChange: onQueryAfiliadoChange,
      disabled: disableFields(),
    };
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={"relative"}
      footerWidth={"auto"}
    >
      <Section>
        <TittleLine title={titulo} weight={"bold"} />
      </Section>

      <Section>
        <AfiliadoForm {...getAfiliadoFormProps()} />
      </Section>

      <Section padding={"5px"}>
        <AutorizacionForm {...getAutorizationFormProps()} />
      </Section>

      <Section align="center" flexDirection={"column"} padding={"10px"}>
        <CustomTable
          columns={columnsProcedimientosAgregados(
            handleOpenModalCoberturas,
            eliminarProcedimiento,
            empresa,
            handleCodigoCobertura,
            codigoCobertura,
            onChangeMontoCobertura,
            montoCobertura,
            homologarCodigoTipoServicio(formData?.tipoServicio)
          )}
          dataSource={tablaProcedimientosData}
          showPagination={false}
          pageSize={100}
          width={"200%"}
        />
      </Section>

      <Section>
        <TittleLine />
      </Section>

      <Section align={"center"} padding={"10px"}>
        <AutorizacionFormButtonsContainer>
          <AutorizacionFormButtonsLeft>
            <CustomButton
              label={"Agregar Procedimiento"}
              onClick={agregarProcedimientoManual}
              disabled={disableFields()}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CustomSeparator width={"10px"} />
            <CheckRender allowed={noRequiereFisico()}>
              <CustomButton
                label={"Adjuntar Soportes"}
                onClick={handleOpenModalDocumentos}
                disabled={disableFields()}
                weight={"bold"}
                hoverColor={empresa?.COLOR_PRINCIPAL}
                bgColor={Colors.white}
                textColor={empresa?.COLOR_PRINCIPAL}
                border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
              />
            </CheckRender>
          </AutorizacionFormButtonsLeft>

          <AutorizacionFormButtonsRight>
            <CustomButton
              label={"Enviar Reclamación"}
              onClick={enviarAutorizacion}
              disabled={disableFields()}
              bgColor={empresa?.COLOR_SECUNDARIO}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              weight={"bold"}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Cancelar"}
              onClick={onCleanForm}
              disabled={disableFields()}
              weight={"bold"}
              hoverColor={Colors.huMyHealth}
              bgColor={Colors.white}
              textColor={Colors.huMyHealth}
              border={`1px solid ${Colors.huMyHealth}`}
            />
          </AutorizacionFormButtonsRight>
        </AutorizacionFormButtonsContainer>
      </Section>

      <CustomModal
        isOpen={isModalCoberturasOpen}
        onClose={handleCloseModalCoberturas}
      >
        <ProcedimientosModal
          query={queryProcedimientos}
          onQueryChange={onQueryProcedimientosChange}
          columnsProcedimientos={columnsProcedimientosPermitidos(
            agregarProcedimientoDesdeModal,
            empresa
          )}
          dataProcedimientos={procedimientosBusqueda}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          totalRegistros={
            props?.getProcedimientosPssData?.paginacion?.totalRegistros
          }
        />
      </CustomModal>

      <CustomModal
        isOpen={isModalDocumentosOpen}
        onClose={handleCloseModalDocumentos}
      >
        <CustomFileUpload
          accept=".jpg,.png,.jpeg,.pdf"
          label="Documentos"
          multiple
          files={documents}
          setFiles={setDocuments}
          buttonColor={empresa?.COLOR_PRINCIPAL}
        />
      </CustomModal>

      <CheckRender allowed={showModalLoader()}>
        <ModalLoader />
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  nuevaSesionData: state.auth.nuevaSesionData,
  nuevaSesionLoading: state.auth.nuevaSesionLoading,
  nuevaSesionError: state.auth.nuevaSesionError,

  consultarAseguradoData: state.asegurado.consultarAseguradoData,
  consultarAseguradoLoading: state.asegurado.consultarAseguradoLoading,
  consultarAseguradoError: state.asegurado.consultarAseguradoError,

  limpiarDatosAseguradoLoading: state.asegurado.limpiarDatosAseguradoLoading,

  getProcedimientosPssData: state.prestador.getProcedimientosPssData,
  getProcedimientosPssLoading: state.prestador.getProcedimientosPssLoading,
  getProcedimientosPssError: state.prestador.getProcedimientosPssError,

  validarProcedimientoData: state.procedimiento.validarProcedimientoData,
  validarProcedimientoLoading: state.procedimiento.validarProcedimientoLoading,
  validarProcedimientoError: state.procedimiento.validarProcedimientoError,

  crearAutorizacionData: state.autorizacion.crearAutorizacionData,
  crearAutorizacionLoading: state.autorizacion.crearAutorizacionLoading,
  crearAutorizacionError: state.autorizacion.crearAutorizacionError,

  getZonasData: state.catalogo.getZonasData,
  getZonasLoading: state.catalogo.getZonasLoading,
  getZonasError: state.catalogo.getZonasError,

  getProvinciasData: state.catalogo.getProvinciasData,
  getProvinciasLoading: state.catalogo.getProvinciasLoading,
  getProvinciasError: state.catalogo.getProvinciasError,

  getDiagnosticosData: state.catalogo.getDiagnosticosData,
  getDiagnosticosLoading: state.catalogo.getDiagnosticosLoading,
  getDiagnosticosError: state.catalogo.getDiagnosticosError,

  getMedicosData: state.prestador.getMedicosData,
  getMedicosLoading: state.prestador.getMedicosLoading,
  getMedicosError: state.prestador.getMedicosError,
});

const mapDispatchToProps = {
  nuevaSesion: AuthActions.nuevaSesion,
  clearSesion: AuthActions.clearSesion,
  consultarAsegurado: AseguradoActions.consultarAsegurado,
  limpiarDatosAfiliado: AseguradoActions.limpiarDatosAsegurado,
  limpiarDatosAutorizacion: AutorizacionActions.limpiarDatosAutorizacion,
  getProcedimientosPss: PrestadorActions.getProcedimientosPss,
  getMedicos: PrestadorActions.getMedicos,
  validarProcedimiento: ProcedimientoActions.validarProcedimiento,
  crearAutorizacion: AutorizacionActions.crearAutorizacion,
  getDiagnosticos: CatalogoActions.getDiagnosticos,
  getZonas: CatalogoActions.getZonas,
  getProvincias: CatalogoActions.getProvincias,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AutorizacionScreen);
